angular.module('unergie.main')
.filter('paymentTrigger', () =>
    function (val) {
        switch (val) {
            case 'PROVIDER': return 'Plüm'
            case 'CLIENT': return 'Client'
            case 'AUTO_RETRY': return 'Rejeu auto'
            default: return '???'
        }
    }
)
